import { monthArray } from './config';

export const formatTime = (data) => {
  const date = new Date(data);
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = String(date.getDate()).padStart(2, '0');
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12 || 12;
  hours = String(hours).padStart(2, '0');
  let strTime = `${monthArray[month]} ${day}, ${year} ${hours}:${minutes} ${ampm}`;
  return strTime;
};
